<div class="event-info-card">
  <div
    class="header"
    [style]="expanded ? 'margin-bottom:20px;' : 'margin-bottom:0px;'"
  >
    <p class="header-title">{{ event.name }}</p>
    <span
    style="cursor:pointer;"
    class="material-symbols-outlined expand-btn" (click)="toggle()">{{
      !expanded ? 'arrow_circle_up' : 'arrow_circle_down'
    }}</span>
  </div>

  <div class="info-section" *ngIf="expanded">
    <div class="icon">
      <svg viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
    </div>
    <div class="info-content">
      <div class="label">Fecha</div>
      <div class="value">{{ date }}</div>
    </div>
  </div>

  <div class="info-section" *ngIf="event.place && expanded">
    <div class="icon">
      <svg viewBox="0 0 24 24">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
    </div>
    <div class="info-content">
      <div class="label">Ubicación</div>
      <div class="value">{{ event.place }}</div>
    </div>
  </div>
</div>
